import http from "./httpService";

export function getAllTemplateService() {
  return http.get("/TemplateApi/GetActiveTemplate").then(({ data }) => data);
}
